import React, { useContext } from 'react';
import { TopBar } from '../common/TopBar';
import { Sidebar } from '../common/Sidebar';
import { Route, Switch } from 'react-router-dom';
import { SettingsMenu } from '../settings/SettingsMenu'
import { SettingsAccount } from '../settings/SettingsAccount'
import { SettingsPhysicalCards } from '../settings/SettingsPhysicalCards'
import { SettingsUserSettings } from '../settings/SettingsUserSettings'
import { SettingsNotifications } from '../settings/SettingsNotifications'
import { SettingsIntegrations } from '../settings/SettingsIntegrations'
import { AppContext } from '../../context/app/appContext';

export const SettingsPage = (props) => {
    const appContext = useContext(AppContext);
    return (
        <div id="app">
            <div id="content" style={{ display: 'flex', height: '100vh' }}>
                <span style={{ width: '10vw', height: '100vh' }}>
                    <Sidebar />
                </span>
                <span style={{ width: '90vw', height: '100vh' }}>
                    <div style={{ width: '100%', height: '10vh' }}>
                        <TopBar />
                    </div>
                    <div style={{ width: '90vw', height: '91.5vh', overflowY: 'scroll', overflowX: 'visible' }}>
                        <SettingsMenu />
                        <div>
                            <Switch>
                                <Route path="/settings/integrations"><SettingsIntegrations organization={appContext.organization} /></Route>
                                <Route path="/settings/physical-cards"><SettingsPhysicalCards organization={appContext.organization} /></Route>
                                <Route path="/settings/user-settings"><SettingsUserSettings organization={appContext.organization} /></Route>
                                <Route path="/settings/notifications"><SettingsNotifications /></Route>
                                <Route path="/settings"><SettingsAccount organization={appContext.organization} /></Route>
                            </Switch>
                        </div>
                    </div>
                </span>
            </div>
        </div>
    );
};
